var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BoxWrap", { attrs: { title: _vm.$t("loginLog.BoxWrap.manage") } }, [
        _c(
          "div",
          { attrs: { slot: "header-right" }, slot: "header-right" },
          [
            _c(
              "el-button",
              {
                attrs: {
                  type: "primary",
                  size: "small",
                  icon: "el-icon-search",
                },
                on: { click: _vm.searchData },
              },
              [_vm._v(_vm._s(_vm.$t("common.search")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "action-container" },
          [
            _c(
              "el-form",
              { attrs: { size: "small", inline: "", "label-position": "top" } },
              [
                _c(
                  "el-row",
                  {
                    staticClass: "row-bg",
                    attrs: { type: "flex", justify: "space-between" },
                  },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("loginLog.input.loginCode"),
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: _vm.$t(
                                  "loginLog.input.loginCodeHolder"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.searchVal.loginCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchVal, "loginCode", $$v)
                                },
                                expression: "searchVal.loginCode",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("loginLog.input.ipAddr") } },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: _vm.$t(
                                  "loginLog.input.ipAddrHolder"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.searchVal.ipAddr,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchVal, "ipAddr", $$v)
                                },
                                expression: "searchVal.ipAddr",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("loginLog.input.startTime"),
                            },
                          },
                          [
                            _c("el-date-picker", {
                              attrs: {
                                clearable: "",
                                type: "datetime",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                placeholder: _vm.$t(
                                  "loginLog.input.startTimeHolder"
                                ),
                              },
                              model: {
                                value: _vm.searchVal.startTime,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchVal, "startTime", $$v)
                                },
                                expression: "searchVal.startTime",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  {
                    staticClass: "row-bg",
                    attrs: { type: "flex", justify: "space-between" },
                  },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("loginLog.input.endTime") },
                          },
                          [
                            _c("el-date-picker", {
                              attrs: {
                                clearable: "",
                                type: "datetime",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                placeholder: _vm.$t(
                                  "loginLog.input.endTimeHolder"
                                ),
                              },
                              model: {
                                value: _vm.searchVal.endTime,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchVal, "endTime", $$v)
                                },
                                expression: "searchVal.endTime",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "BoxWrap",
        {
          staticClass: "main-table-container",
          attrs: { title: _vm.$t("loginLog.BoxWrap.list") },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                stripe: "",
                "highlight-current-row": "",
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  index: _vm.tableIndex,
                  label: _vm.$t("loginLog.table.systemPk"),
                  width: "80",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "loginLogPk",
                  label: _vm.$t("loginLog.table.loginLogPk"),
                  width: "100",
                  align: "center",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "loginCode",
                  label: _vm.$t("loginLog.table.loginCode"),
                  width: "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "sessionid",
                  label: _vm.$t("loginLog.table.sessionid"),
                  "min-width": "180",
                  align: "center",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "ipAddr",
                  label: _vm.$t("loginLog.table.ipAddr"),
                  "min-width": "140",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "loginInDatetime",
                  label: _vm.$t("loginLog.table.loginInDatetime"),
                  width: "140",
                  align: "center",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "loginOutDatetime",
                  label: _vm.$t("loginLog.table.loginOutDatetime"),
                  width: "140",
                  align: "center",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("loginLog.table.extAttr"),
                  "min-width": "140",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("p", [_vm._v(_vm._s(scope.row.extAttr1))]),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(scope.row.extAttr2))]),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(scope.row.extAttr3))]),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(scope.row.extAttr4))]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "userPk",
                  label: _vm.$t("loginLog.table.userPk"),
                  width: "100",
                  align: "center",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "unionid",
                  label: _vm.$t("loginLog.table.unionid"),
                  "min-width": "100",
                  align: "center",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "remark",
                  label: _vm.$t("loginLog.table.remark"),
                  width: "100",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total>0",
              },
            ],
            attrs: { total: _vm.total, page: _vm.currPage, limit: _vm.limit },
            on: {
              "update:page": function ($event) {
                _vm.currPage = $event
              },
              "update:limit": function ($event) {
                _vm.limit = $event
              },
              pagination: _vm.fetchData,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }